var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2",class:{ 'px-3': _vm.$vuetify.breakpoint.mdAndUp }},[(_vm.classData)?_c('Breadcrumbs',{class:{ 'px-4 mt-2': _vm.$vuetify.breakpoint.smAndDown },attrs:{"data":"classData.title","headline":_vm.classData.title,"link":[
      { text: 'Danh sách lớp', href: '../../../classes' },
      {
        text: _vm.classData.title,
        id: _vm.classData.id,
        href: ("../../class/" + (_vm.classData.id))
      },
      { text: 'Sổ Điểm' }
    ]}}):_vm._e(),_c('v-card',{staticClass:"mt-7"},[(!_vm.slots)?_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"300","type":"table-heading"}}):_c('marks',{attrs:{"classData":_vm.classData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }